import React, {useContext} from "react";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import {NavLink} from "react-router-dom";
import {LanguageContext} from "../../context/LanguageContext";
import PropTypes from "prop-types";
import {styled} from "@mui/system";
import {ListItemButton} from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Rendered from "../Rendered";
import {contactHasRight} from "../../utils/commonFunctions";
import {CustomerContext} from "../../context/CustomerContext";

// source: https://stackoverflow.com/questions/68814908/can-you-pass-custom-props-to-material-ui-v5-styled-components
const ListItemButtonStyled = styled(ListItemButton, {
  shouldForwardProp: (prop) => !["parent", "withoutActiveStyle", "active", "activeChild"].includes(prop)
})(({ theme, ...props }) => ({
  ...(props.parent && {
    position: "relative",
    display: "inline-flex",
    upperBold: {
      fontWeight: "bold"
    },
    "& > div > span": {
      fontWeight: "bold"
    }
  }),
  width: "auto",
  color: theme.palette.primary.main,
  "&::after": {
    content: '""',
    display: "block",
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    transform: "scaleX(0)",
    transition: "transform 200ms ease-in-out"
  },
  "&:hover": {
    backgroundColor: theme.palette.primary.contrastText,
    textDecoration: props.parent ? "none" : "underline",
    "&::after": {
      transform: "scaleX(1)"
    }
  },
  ...((props.active || props.activeChild) && {
    "&, &:hover, &.active": {
      backgroundColor: theme.palette.primary.contrastText,
      color: theme.palette.secondary.main,
      textDecoration: props.activeChild ? "none" : "underline",
      textUnderlineOffset: 8,
      textDecorationThickness: 2
    }
  })
}));

const GenericMenuItem = ({ menuItem, onClick, selectedMenuItem, parent }) => {
  const customerContext = useContext(CustomerContext);
  const languageContext = useContext(LanguageContext);
  const active = selectedMenuItem?.label === menuItem.label;
  const activeChild = new RegExp(`^${menuItem.url}(\\/.*)?$`).test(window.location.pathname);

  return (
    <Rendered rendered={!!contactHasRight(customerContext.selectedContact.roles, menuItem.access) && !menuItem.hidden}>
      <ListItemButtonStyled
        component={NavLink}
        to={{ pathname: menuItem.url, state: { from: window.location.pathname } }}
        onClick={event => onClick?.(event, menuItem)}
        disableRipple
        active={active}
        activeChild={activeChild}
        parent={parent}
      >
        <Rendered rendered={!parent}>
          <ListItemIcon sx={{ color: "inherit", minWidth: 20 }}>
            <KeyboardArrowRightIcon style={{ fontSize: 16 }} />
          </ListItemIcon>
        </Rendered>
        <ListItemText
          primaryTypographyProps={{ fontSize: parent ? "16px" : "14px" }}
          primary={languageContext.dictionary[menuItem.label] || menuItem.label}
        />
        <Rendered rendered={!!menuItem.children}>
          {active ? (
            <ExpandLess fontSize="small" sx={{ color: "secondary.main" }} />
          ) : (
            <ExpandMore fontSize="small" />
          )}
        </Rendered>
      </ListItemButtonStyled>
    </Rendered>
  );
};

GenericMenuItem.propTypes = {
  menuItem: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  withIcon: PropTypes.bool,
  selectedMenuItem: PropTypes.object,
  parent: PropTypes.bool
};

export default GenericMenuItem;
